import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import QRCode from "./QRCode";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Upload,
  message,
} from "antd";
import _ from "lodash";

import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PdfWithQrCode from "./PdfWithQrCode";
var utf8 = require("utf8");

const { TextArea } = Input;
const { Option } = Select;
const { forwardRef, useRef, useImperativeHandle } = React;
export const SpotForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [spotType, setSpotType] = useState(null);
  const [patrollingPerson, setPatrollingPerson] = useState(null);
  const [user, SetUser] = useState({});
  const [basicDistricts, SetBasicDistricts] = useState([]);
  const [pc_cities, SetPC_cities] = useState([]);
  const [isSave, setIsSave] = useState(null);
  const [fileData, setFileData] = useState({});
  const [imageUrl, setImageUrl] = useState("");
  const [url, setUrl] = useState("");
  const [options, setOptions] = useState();
  const [citySelected, SetCitySelected] = useState(false);
  const [stateSelected, SetStateSelected] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [district, seDistrict] = useState([]);
  const [spot, setSpot] = useState([]);
  const [qrId, setCodeId] = useState("");
  const [pendingObj, setPendingObj] = useState(null);

  useEffect(() => {
    SetUser(props.user);
  }, [props.user]);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({ spotType: "" });
    form.setFieldsValue({ district: "" });
    form.setFieldsValue({ spotName: "" });
    form.setFieldsValue({ spot_time: "" });
    form.setFieldsValue({ landmark: "" });

    if (props.resetFrom && props.resetFrom) {
      form.resetFields();
      form.setFieldsValue({ spotType: "" });
      form.setFieldsValue({ district: "" });
      form.setFieldsValue({ spotName: "" });
      form.setFieldsValue({ spot_time: "" });
      form.setFieldsValue({ landmark: "" });
      setUrl("");
    }
    form.setFieldsValue({ city: getCityName(props.user.cityId) });
    SetCitySelected(true);
    props.onCityChange(props.user.cityId, 1);
  }, [props.resetFrom]);

  useEffect(
    (res) => {
      if (
        props.dataStates &&
        props.dataStates.pc_countrystates &&
        props.dataStates.pc_countrystates
      ) {
        setStates([...props.dataStates.pc_countrystates]);
      }
      if (
        props.dataStates &&
        props.dataStates.pc_cities &&
        props.dataStates.pc_cities
      ) {
        setCities([...props.dataStates.pc_cities]);
      }
      if (props && props.spotType) {
        setSpot([...props.spotType]);
      }
      if (props && props.patrollingPerson) {
        setPatrollingPerson([...props.patrollingPerson]);
      }
    },
    [props.dataStates]
  );

  useEffect(
    (res) => {
      if (props.dataStates && props.dataStates.basicDistricts) {
        seDistrict([...props.dataStates.basicDistricts]);
      }
    },
    [props.dataStates && props.dataStates.basicDistricts]
  );

  useImperativeHandle(ref, () => ({
    onFinish(flag) {
      setIsSave(flag);
      form.submit();
    },
  }));

  const onFinish = (values) => {
    if (isSave) {
      generateQRCode(values);
    } else {
      props.onFormUpdate(values);
    }
  };

  function makeid(length) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  function generateQRCode(values) {
    let district;
    let city = user && user.cityId;
    if (user && user.role === "4") {
      district = values.district;
    } else {
      district = user && user.districtId;
    }
    let strNum = makeid(15);
    const qrOBJ =
      strNum +
      "|" +
      utf8.encode(values.spotName) +
      "|" +
      values.spotType +
      "|" +
      utf8.encode(values.landmark) +
      "|" +
      city +
      "|" +
      district;
    const hashedQR = base64_encode(qrOBJ);
    console.log("from obj=====>", strNum);
    console.log("form hashedQR====>", hashedQR);
    setCodeId(strNum);

    if (values) {
      setOptions({
        ecLevel: "M", //The error correction level of the QR Code
        enableCORS: false, //Enable crossorigin attribute
        size: 300, //The size of the QR Code
        quietZone: 10, //The size of the quiet zone around the QR Code. This will have the same color as QR Code bgColor
        bgColor: "#FFFFFF", //Background color
        fgColor: "gray", //Foreground color
        logoImage:
          "https://webisora.com/wp-content/uploads/2017/09/WebisoraLogo_B.png", //The logo image. It can be a url/path or a base64 value
        logoWidth: 180,
        logoHeight: 40,
        logoOpacity: 1,
        qrStyle: "squares", //Style of the QR Code modules - dots or squares
      });
      setUrl(hashedQR);

      document.getElementById("qrcode-container").style.display = "block";
      let obj = {
        ...values,
        qr_id: strNum,
      };
      console.log("value form======>", values);
      console.log("obj form======>", obj);
      props.onFormFinish(obj);
    } else {
      alert("Please enter a valid spotType");
    }
  }

  const genratepdf = () => {
    <PDFDownloadLink
      document={<PdfWithQrCode url={url} />}
      fileName="somename.pdf"
    >
      {({ loading }) => (loading ? "Loading document..." : "Download now!")}
    </PDFDownloadLink>;
  };

  // download QR code
  const downloadQRCode = () => {
    const qrCodeURL = document
      .getElementById("react-qrcode-logo")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let name = document.getElementById("spotName").value;
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code" + name + ".png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const getDistrictName = (id) => {
    const { basicDistricts } = props.dataStates;
    if (basicDistricts && basicDistricts.length) {
      return (
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };

  const getCityName = (id) => {
    const { pc_cities } = props.dataStates;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  const clearDistrictSelected = () => {
    form.resetFields(["district"]);
  };

  // useEffect(() => {
  //   if (url && pendingObj) {
  //     // Wait a tick for the QR code to render
  //     setTimeout(() => {
  //       const qrCodeElement = document.getElementById("react-qrcode-logo");
  //       if (qrCodeElement) {
  //         const qrCodeURL = qrCodeElement
  //           .toDataURL("image/png")
  //           .replace("image/png", "image/octet-stream");
  //         props.onFormFinish({ ...pendingObj, qr_code: qrCodeURL });
  //         setPendingObj(null); // Reset
  //       }
  //     }, 100); // 100ms delay to ensure DOM is updated
  //   }
  // }, [url, pendingObj]);

  console.log("url=====>",url)
  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            name="spotType"
            label="Spot Type"
            rules={[
              {
                required: true,
                message: "Please select an spot type",
              },
            ]}
          >
            <Select
              placeholder="Please select an spot type"
              rules={[{ required: true, message: "Please select spot type" }]}
              style={{ width: "100%" }}
              value={spotType}
              onChange={(e) => {
                setSpotType(e);
              }}
            >
              <Option value="">Select Type</Option>
              {spot &&
                spot.length &&
                spot.map((res, index) => (
                  <Option key={index} value={res.id}>
                    {res.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        {user && user.role === "4" ? (
          <Col span={8}>
            <Form.Item
              name="district"
              label="पोलिस ठाणे"
              rules={[
                { required: true, message: "Please enter user district" },
              ]}
            >
              <Select
                optionFilterProp="children"
                placeholder="Please select an district"
                disabled={!citySelected}
              >
                {district &&
                  district.length &&
                  district.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.DistrictName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        ) : (
          ""
        )}
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            name="spotName"
            label="Spot Name"
            rules={[{ required: true, message: "Spot Name is required" }]}
          >
            <Input placeholder="Please enter spot name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="spot_time"
            label="Spot Time"
            rules={[{ required: true, message: "Spot Time is required" }]}
          >
            <Select
              optionFilterProp="children"
              placeholder="Please select an Spot Time"
            >
              <Option key={0} value="">
                Select
              </Option>
              <Option key={1} value="day">
                Day
              </Option>
              <Option key={2} value="night">
                Night
              </Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            name="landmark"
            label="Landmark"
            rules={[{ required: true, message: "Landmark is required" }]}
          >
            <Input placeholder="Please enter landmark" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="patrolling_person"
            label="Patrolling Person"
            rules={[
              { required: true, message: "Please enter Patrolling Person" },
            ]}
          >
            <Select
              optionFilterProp="children"
              placeholder="Please select an Patrolling"
            >
              {patrollingPerson &&
                patrollingPerson.length &&
                patrollingPerson.map((res, index) => (
                  <Option key={index} value={res.name}>
                    {res.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <div id="qrcode-container" style={{ textAlign: "center" }}>
        <hr />
        {url && url!="" ? (
          <>
            <QRCode url={url} options={options} />
            <Row gutter={24}>
              <Col span={24}>
                <Button onClick={downloadQRCode} type="primary">
                  Download
                </Button>
              </Col>
            </Row>
          </>
        ) : null}
      </div>
    </Form>
  );
});
